import React, { useContext, useEffect, useState } from 'react';
import { FaUsers, FaCartPlus, FaTruckLoading, FaCheckCircle, FaRupeeSign } from "react-icons/fa";
import { Card } from "react-bootstrap";
import axios from 'axios';
import { ThemeContext } from "../../../context/ThemeContext.js";
import { var_api } from '../../../constant';
import { toast } from "react-toastify";

import { Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  ArcElement
} from "chart.js";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, ArcElement);

const WarehouseDashboard = () => {
  const { changeBackground } = useContext(ThemeContext);
  const [dashboardData, setDashboardData] = useState({
    today_orders: 0,
    today_sales: 0,
    new_orders: 0,
    not_delivered: 0,
    delivered: 0
  });
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [recentOrders, setRecentOrders] = useState([]);
  const [recentDate, setRecentDate] = useState(new Date().toISOString().slice(0, 10));
  const [salesGraph, setSalesGraph] = useState([]);
  const [topSelling, setTopSelling] = useState([]);

  const [showSubModal, setShowSubModal] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [paying, setPaying] = useState(false);
  const [subMessageOnly, setSubMessageOnly] = useState(false);



  const warehouseId = localStorage.getItem("warehouse_id"); // 🔹 dynamic

  // Fetch dashboard, recent orders, sales graph
  const fetchDashboard = async () => {
    if (!warehouseId) return;
    try {
      setLoading(true);
      const ordersRes = await axios.get(`${var_api}veemart_instore_pos_billing/get-orders-count/${warehouseId}`);
      console.log("Dashboard Orders Response:", ordersRes.data);
      if (ordersRes.data && ordersRes.data.dashboard) setDashboardData(ordersRes.data.dashboard);

      const custRes = await axios.get(`${var_api}veemart_instore_customers/get-customer-count/${warehouseId}`);
      console.log("Customer Count Response:", custRes.data.cust_count );
      if (custRes.data) setTotalCustomers(custRes.data.cust_count || 0);
    } catch (err) {
      console.error("Failed to fetch dashboard data", err);
      toast.error("Failed to fetch dashboard data");
    } finally { setLoading(false); }
  };

  const checkSubscriptionStatus = async () => {
  if (!warehouseId) return;

  try {
    const res = await axios.get(
      `${var_api}subscription/check-current-month/${warehouseId}`
    );

    // ❌ Case 1: No subscription created for this month
    if (res.data?.success === false && res.data?.exists === false) {
      setSubMessageOnly(true);
      setShowSubModal(true);
      setSubscriptionData(res.data)
      return;
    }

    // ❌ Case 2: Subscription exists but not paid
    if (res.data?.success === false && res.data?.is_paid === false) {
      setSubMessageOnly(false);
      setShowSubModal(true);
      setSubscriptionData(res.data);
      return;
    }

  } catch (err) {
    console.error("Subscription check failed", err);
  }
};


  const fetchRecentOrders = async (date) => {
    if (!warehouseId) return;
    try {
      setLoading(true);
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/get-recent-orders/${warehouseId}`, { params: { date } });
      if (res.data?.status) setRecentOrders(res.data.orders || []);
      else setRecentOrders([]);
    } catch (err) {
      console.error("Failed to fetch recent orders", err);
      toast.error("Failed to fetch recent orders");
    } finally { setLoading(false); }
  };

  const fetchSalesGraph = async () => {
    if (!warehouseId) return;
    try {
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/get-sales-graph/${warehouseId}`);
      if (res.data?.status) setSalesGraph(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch sales graph", err);
      toast.error("Failed to load sales graph");
    }
  };

  const fetchTopSellingProducts = async () => {
    if (!warehouseId) return;
    try {
      const res = await axios.get(`${var_api}veemart_instore_pos_billing/get-top-selling-products/${warehouseId}`);
      if (res.data?.status) setTopSelling(res.data.top_selling || []);
    } catch (err) {
      console.error("Failed to fetch top selling products", err);
      toast.error("Failed to load top selling products");
    }
  };

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    fetchDashboard();
    fetchRecentOrders(recentDate);
    fetchSalesGraph();
    fetchTopSellingProducts();

     checkSubscriptionStatus(); // ✅ ADD THIS
  }, []);


  const handlePayNow = async () => {
  try {
    setPaying(true);

    // 1️⃣ Create Razorpay order (backend API)
    const orderRes = await axios.post(
      `${var_api}subscription/create-razorpay-order`,
      {
        warehouse_id: warehouseId,
        amount: parseFloat(subscriptionData?.total_unpaid_amount || 0) // example subscription amount
      }
    );

    const { order_id, amount, key } = orderRes.data;

    // 2️⃣ Open Razorpay
    const options = {
      key,
      amount,
      currency: "INR",
      name: "Veemart Subscription",
      description: "Monthly Subscription",
      order_id,
      handler: async function (response) {
        // 3️⃣ Verify payment
        await axios.post(`${var_api}subscription/verify-payment`, {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          warehouse_id: warehouseId,
        });

        toast.success("Subscription paid successfully 🎉");
        setShowSubModal(false);
        fetchDashboard(); // refresh
      },
      prefill: {
        name: "Warehouse Admin",
      },
      theme: {
        color: "#0d6efd",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();

  } catch (err) {
    console.error("Payment failed", err);
    toast.error("Payment failed");
  } finally {
    setPaying(false);
  }
};



const totalSold = topSelling.reduce(
  (sum, item) => sum + Number(item.total_qty_sold),
  0
);

  // Line chart
  const lineChartData = {
    labels: salesGraph.map(item => item.date),
    datasets: [{
      label: "Daily Sales",
      data: salesGraph.map(item => item.total_sales),
      borderWidth: 3,
      tension: 0.3,
      fill: false,
      borderColor: "#007bff",
      pointBorderColor: "#007bff",
      pointBackgroundColor: "#fff",
    }]
  };
  const lineChartOptions = { responsive: true, plugins: { legend: { display: true } }, scales: { y: { beginAtZero: true } } };

  // Pie chart for top selling products
  const pieChartData = {
    labels: topSelling.map(item => item.product_name),
    datasets: [{
      data: topSelling.map(item => item.total_qty_sold),
      backgroundColor: [
        "#e60d3cff", "#148cddff", "#eead08ff", "#1fde1fff", "#570cedff", "#e7ea07ff"
      ],
      hoverOffset: 10,
    }]
  };
const pieChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
    },
    datalabels: {
      color: "#fff",
      font: {
        weight: "bold",
        size: 12,
      },
      formatter: (value, context) => {
        const percentage = ((value / totalSold) * 100).toFixed(1);
        const label = context.chart.data.labels[context.dataIndex];
        return `${label}\n${percentage}%`;
      },
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const value = context.raw;
          const percent = ((value / totalSold) * 100).toFixed(1);
          return `${context.label}: ${value} (${percent}%)`;
        },
      },
    },
  },
};


 return (
  <>
    <div className="container-fluid px-3">

      {/* Top Metrics */}
      <div className="row g-4 mt-2">

        {/* Total Customers */}
        <div className="col-xl-3 col-sm-6">
          <div className="card shadow-sm border-0" style={{ borderRadius: "14px" }}>
            <div className="card-body d-flex align-items-center py-4">
              <div className="p-3 rounded-circle" style={{ background: "#e7f1ff" }}>
<FaUsers size={32} color="#007bff" />
              </div>
              <div className="ms-4">
                <h3 className="mb-1 fw-bold">{totalCustomers}</h3>
                <p className="text-muted mb-0">Total Customers</p>
              </div>
            </div>
          </div>
        </div>

        {/* New Orders */}
        <div className="col-xl-3 col-sm-6">
          <div className="card shadow-sm border-0" style={{ borderRadius: "14px" }}>
            <div className="card-body d-flex align-items-center py-4">
              <div className="p-3 rounded-circle" style={{ background: "#fff4e5" }}>
<FaCartPlus size={32} color="#ff9800" />
              </div>
              <div className="ms-4">
                <h3 className="mb-1 fw-bold">{dashboardData.new_orders}</h3>
                <p className="text-muted mb-0">New Orders</p>
              </div>
            </div>
          </div>
        </div>

        {/* Orders In Progress */}
        <div className="col-xl-3 col-sm-6">
          <div className="card shadow-sm border-0" style={{ borderRadius: "14px" }}>
            <div className="card-body d-flex align-items-center py-4">
              <div className="p-3 rounded-circle" style={{ background: "#fff0f0" }}>
<FaTruckLoading size={32} color="#e63946" />
              </div>
              <div className="ms-4">
                <h3 className="mb-1 fw-bold">{dashboardData.not_delivered}</h3>
                <p className="text-muted mb-0">Orders In Progress</p>
              </div>
            </div>
          </div>
        </div>

        {/* Delivered Orders */}
        <div className="col-xl-3 col-sm-6">
          <div className="card shadow-sm border-0" style={{ borderRadius: "14px" }}>
            <div className="card-body d-flex align-items-center py-4">
              <div className="p-3 rounded-circle" style={{ background: "#e9ffe6" }}>
<FaCheckCircle size={32} color="#28a745" />
              </div>
              <div className="ms-4">
                <h3 className="mb-1 fw-bold">{dashboardData.delivered}</h3>
                <p className="text-muted mb-0">Delivered Orders</p>
              </div>
            </div>
          </div>
        </div>

      </div> {/* <-- CLOSE Top Metrics ROW */}

      {/* === Today Sales + Recent Orders Row === */}
      <div className="row g-4 mt-2">

        {/* Today Sales */}
        <div className="col-xl-3 col-lg-4 col-md-5">
          <div className="card shadow-sm border-0 h-100" style={{ borderRadius: "14px" }}>
            <div className="card-body d-flex align-items-center py-4">
              <div className="p-3 rounded-circle" style={{ background: "#f0e8ff" }}>
<FaRupeeSign size={32} color="#6f42c1" />
              </div>
              <div className="ms-4">
                <h3 className="mb-1 fw-bold">₹ {dashboardData.today_sales}</h3>
                <p className="text-muted mb-0">Today's Sales</p>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Orders */}
       <div className="col-xl-9 col-lg-8 col-md-7">
  <div
    className="card shadow-lg border-0 h-100"
    style={{ borderRadius: "18px", width: "550px" }} // reduce width
  >
    <div
      className="card-header d-flex justify-content-between align-items-center py-3"
      style={{ background: "#f9fafc", borderTopLeftRadius: "18px", borderTopRightRadius: "18px" }}
    >
      <h4 className="mb-0 fw-bold">Recent Orders</h4>

      <input
        type="date"
        className="form-control form-control-sm shadow-sm"
        style={{ width: "170px", borderRadius: "8px", border: "1px solid #d0d7de" }}
        value={recentDate}
        onChange={(e) => {
          setRecentDate(e.target.value);
          fetchRecentOrders(e.target.value);
        }}
      />
    </div>

    <div className="card-body p-0">
      <div style={{ maxHeight: "350px", overflowY: "auto" }}>
        {recentOrders.length === 0 ? (
          <div className="p-4 text-center text-muted">No orders found</div>
        ) : (
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map((order) => (
                <tr key={order.order_id}>
                  <td className="fw-semibold">{order.order_no}</td>
                  <td>{order.customer_name}</td>
                  <td className="fw-semibold">₹ {order.total_amount}</td>
                  <td>
                    <span
                      className={`badge px-3 py-2 ${
                        order.status?.toLowerCase() === "delivered"
                          ? "bg-success"
                          : order.status?.toLowerCase() === "pending"
                          ? "bg-warning text-dark"
                          : "bg-secondary"
                      }`}
                      style={{ borderRadius: "30px" }}
                    >
                      {order.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
</div>


      </div> {/* <-- CLOSE Today Sales + Recent Orders ROW */}
  {/* Sales Trend Line Chart */}
  <div className="row mt-4">
  {/* Sales Trend - Left */}
  <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
    <div className="card shadow-lg border-0" style={{ borderRadius: "18px" }}>
      <div className="card-header" style={{ background: "#f9fafc", borderTopLeftRadius: "18px", borderTopRightRadius: "18px" }}>
        <h4 className="fw-bold mb-0">Sales Trend</h4>
      </div>
      <div className="card-body">
        {salesGraph.length === 0 ? (
          <p className="text-center text-muted py-5">No sales graph data available</p>
        ) : (
          <Line data={lineChartData} options={lineChartOptions} height={90} />
        )}
      </div>
    </div>
  </div>

  {/* Top Selling Products - Right */}
<div className="col-xl-6 col-lg-6 col-md-12 mb-4">
  <div
    className="card shadow border-0"
    style={{ borderRadius: "20px", background: "#fff" }}
  >
    {/* HEADER */}
    <div
      className="card-header"
      style={{
        background: "#f8faff",
        padding: "16px 20px",
        borderBottom: "1px solid #eef1f5",
      }}
    >
      <h4 className="fw-bold mb-0">📦 Top Selling Products</h4>
    </div>

    {/* BODY */}
    <div className="card-body">
      {topSelling.length === 0 ? (
        <p className="text-center text-muted">No data available</p>
      ) : (
        <>
          <div className="row">
            {/* PIE CHART */}
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div style={{ width: "260px", height: "260px" }}>
                <Pie data={pieChartData} options={pieChartOptions} />
              </div>
            </div>

            {/* SUMMARY TABLE */}
            <div className="col-md-6">
              <h6 className="fw-bold mb-2">Product Summary</h6>

              <div style={{ maxHeight: "220px", overflowY: "auto" }}>
                <table className="table table-sm table-bordered mb-0">
                  <thead style={{ background: "#f1f4f8" }}>
                    <tr>
                      <th>Product</th>
                      <th>Sold</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topSelling.map((item) => (
                      <tr key={item.product_id}>
                        <td>{item.product_name}</td>
                        <td className="fw-bold text-primary">
                          {item.total_qty_sold}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* LEGEND (BOTTOM LIKE PHOTO) */}
          <div className="d-flex justify-content-center gap-4 mt-3">
          {/* DYNAMIC LEGEND */}
<div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
  {topSelling.map((item, index) => {
    const percent = ((item.total_qty_sold / totalSold) * 100).toFixed(1);

    return (
      <div
        key={item.product_id}
        className="d-flex align-items-center gap-2"
      >
        <span
          style={{
            width: "12px",
            height: "12px",
            background: pieChartData[index % pieChartData.length],
            display: "inline-block",
            borderRadius: "3px",
          }}
        />
        <h4 className="fw-semibold"> {item.product_name} – {percent}%</h4>
     
      </div>
    );
  })}
</div>


          
          </div>
        </>
      )}
    </div>
  </div>
</div>

</div>

{showSubModal && (
  <div className="subscription-overlay">
    <div className="subscription-modal">

      <FaRupeeSign size={40} color="#dc3545" />

      <h4 className="mt-3">
        {subMessageOnly
          ? "Subscription Not Available"
          : "Subscription Payment Pending"}
      </h4>

      <p className="text-muted mt-2">
        {subMessageOnly
          ? "This month you are not subscribed. Please contact admin."
          : "You did not pay subscription for this month. Please pay to continue."}
      </p>

 <div className="d-flex justify-content-center gap-2 mt-3">
      {!subMessageOnly && (
        <button
          className="btn btn-secondary mt-3"
          onClick={handlePayNow}
        >
          Pay Now
        </button>
      )}

      {/* ⚪ Maybe Later / Close */}
        <button
          className="btn btn-outline-danger mt-3"
          onClick={() => setShowSubModal(false)}
        >
          Maybe Later
        </button>
      </div>

    </div>
  </div>
)}



    </div>
    <style>
      {`
      .subscription-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subscription-modal {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  width: 400px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}
`}
    </style>
  </>
);
};
export default WarehouseDashboard;
